/**
 * VersionSelector - Sélecteur de version v1/v2 pour les articles régénérés
 * Extrait de CreateArticle.js pour améliorer la maintenabilité
 */
import React from 'react';

/**
 * Composant pour sélectionner entre version v1 et v2 d'un article
 */
const VersionSelector = ({
  siteId,
  selectedVersion,
  onSelectVersion,
  v1Article,
  v2Article
}) => {
  if (!v2Article) return null;

  return (
    <div 
      className="mt-3 p-2 bg-purple-500/10 border border-purple-500/30 rounded-lg" 
      data-testid={`version-selector-${siteId}`}
    >
      <div className="flex items-center gap-3">
        <span className="text-xs text-purple-400 uppercase font-semibold">Version :</span>
        <div className="flex gap-2">
          <button
            onClick={() => onSelectVersion(1)}
            className={`px-3 py-1.5 rounded text-xs font-medium transition-all ${
              selectedVersion === 1
                ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/50'
                : 'bg-slate-800/50 text-slate-400 border border-slate-700 hover:border-slate-600'
            }`}
          >
            V1 (originale)
          </button>
          <button
            onClick={() => onSelectVersion(2)}
            className={`px-3 py-1.5 rounded text-xs font-medium transition-all ${
              selectedVersion === 2
                ? 'bg-purple-500/20 text-purple-300 border border-purple-500/50'
                : 'bg-slate-800/50 text-slate-400 border border-slate-700 hover:border-slate-600'
            }`}
          >
            V2 (régénérée)
          </button>
        </div>
        {selectedVersion === 2 && v2Article?.regen_angle && (
          <span 
            className="text-[10px] text-purple-400/70 italic ml-2 truncate max-w-[200px]" 
            title={v2Article.regen_angle}
          >
            Angle : {v2Article.regen_angle.substring(0, 40)}...
          </span>
        )}
      </div>
      
      {/* Mini-comparaison des titres */}
      <div className="mt-2 grid grid-cols-2 gap-2 text-[10px]">
        <div className={`p-1.5 rounded ${
          selectedVersion === 1 ? 'bg-cyan-500/10 border border-cyan-500/30' : 'bg-slate-800/30'
        }`}>
          <span className="text-slate-500">V1 :</span>
          <p className="text-slate-300 truncate">{v1Article?.title}</p>
        </div>
        <div className={`p-1.5 rounded ${
          selectedVersion === 2 ? 'bg-purple-500/10 border border-purple-500/30' : 'bg-slate-800/30'
        }`}>
          <span className="text-slate-500">V2 :</span>
          <p className="text-slate-300 truncate">{v2Article?.title}</p>
        </div>
      </div>
    </div>
  );
};

export default VersionSelector;
